import { render, staticRenderFns } from "./ClimateContext.vue?vue&type=template&id=7c19d9bc&scoped=true"
import script from "./ClimateContext.vue?vue&type=script&lang=js"
export * from "./ClimateContext.vue?vue&type=script&lang=js"
import style0 from "./ClimateContext.vue?vue&type=style&index=0&id=7c19d9bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c19d9bc",
  null
  
)

export default component.exports